import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";
import { REMARK_ICON } from "./refUtils";

// Small reference-markup components shared by the Cricket Match 20-20 / Casino Meter / 1 Card Meter /
// 20-20 D T L / Bollywood Casino pages (live + virtual).

// Reference <Card> component: <span><img src="cards/{card}.png"></span>
export function RefCard({ card }) {
  return (
    <span>
      <img src={getCardImage(card)} alt="" />
    </span>
  );
}

// Reference remark strip (only when the feed has a non-empty remark)
export function RefRemark({ remark }) {
  if (!remark) return null;
  return (
    <div className="casino-remark mt-3">
      <div className="remark-icon">
        <img src={REMARK_ICON} alt="" />
      </div>{" "}
      <marquee>{remark}</marquee>
    </div>
  );
}

export function RangeIcon({ id, open, onToggle, iconClass = "fas fa-info-circle", withExpanded = true, collapsedClass = true }) {
  return (
    <i
      data-toggle="collapse"
      data-target={`#${id}`}
      aria-expanded={withExpanded ? (open ? "true" : "false") : undefined}
      className={`${iconClass}${collapsedClass && !open ? " collapsed" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle(id);
      }}
    />
  );
}
